import React, { useEffect, useState } from 'react';
import { useVideoTexture } from '@react-three/drei';
import * as THREE from 'three';

export function VideoMaterial({ url }) {
  const [hasError, setHasError] = useState<boolean>(false);

  if (!url || typeof url !== 'string') {
    return <meshBasicMaterial color='gray' side={THREE.FrontSide} />;
  }

  if (hasError) {
    return <meshBasicMaterial color='orange' side={THREE.FrontSide} />;
  }

  try {
    const texture = useVideoTexture(url);

    useEffect(() => {
      if (texture) {
        (texture as any).colorSpace = (THREE as any).SRGBColorSpace;
      }
    }, [texture]);

    return <meshBasicMaterial map={texture} side={THREE.FrontSide} />;
  } catch (error) {
    setHasError(true);
    return <meshBasicMaterial color='orange' side={THREE.FrontSide} />;
  }
}
